import { animate, useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

export function AnimatedNumber({ target, suffix = '', prefix = '', duration = 2 }: { target: number; suffix?: string; prefix?: string; duration?: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!isInView) return undefined;
    const controls = animate(0, target, {
      duration,
      ease: 'easeOut' as const,
      onUpdate: (v) => setValue(Math.round(v)),
    });
    return controls.stop;
  }, [isInView, target, duration]);

  return (
    <span ref={ref} className='tabular-nums'>
      {prefix}
      {value.toLocaleString()}
      {suffix}
    </span>
  );
}
